import { IBrandRoutes } from './types';

export const brandRoutes: IBrandRoutes = {};
